import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_sales_commission_pricing_model_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    commission_pricing_model_code: fromDatatype.VarcharDatatypeInterface;
    commission_pricing_model_name: fromDatatype.VarcharDatatypeInterface;
    logic_code: fromDatatype.VarcharDatatypeInterface;
    logic_type: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_sales_commission_pricing_model_hdr_RowClass implements bl_fi_sales_commission_pricing_model_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    commission_pricing_model_code: fromDatatype.VarcharDatatypeInterface;
    commission_pricing_model_name: fromDatatype.VarcharDatatypeInterface;
    logic_code: fromDatatype.VarcharDatatypeInterface;
    logic_type: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
